import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { Period, ValidityPeriodSize } from '@app/shared/components/validity-period/validity-period.component';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as moment from 'moment';
import { SessionService } from '@app/core/services/session.service';


@Component({
    templateUrl: './support-access-dialog.component.html',
    styleUrls: ['./support-access-dialog.component.scss']
})
export class SupportAccessDialogComponent extends BaseWithBundleComponent
                                          implements OnInit {

    public periods: Period[];
    public selectedPeriod: number;
    public periodError: boolean;

    get ValidityPeriodSize() {
        return ValidityPeriodSize;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected sessionService: SessionService,
                public dialogRef: MatDialogRef<ConfirmModalComponent>) {
        super(componentServiceBundle);
        this._idPrefix = 'support_access_dialog';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.periodError = false;

        this.periods = [
            { value: 5, label: `5 ${this.translateService.instant(marker('common.label.minute_code'))}`},
            { value: 15, label: `15 ${this.translateService.instant(marker('common.label.minute_code'))}`},
            { value: 30, label: `30 ${this.translateService.instant(marker('common.label.minute_code'))}`},
            { value: 45, label: `45 ${this.translateService.instant(marker('common.label.minute_code'))}`},
            { value: 60, label: `1 ${this.translateService.instant(marker('common.label.hour_code'))}`},
            { value: 120, label: `2 ${this.translateService.instant(marker('common.label.hour_code'))}`},
            { value: 240, label: `4 ${this.translateService.instant(marker('common.label.hour_code'))}`},
            { value: 480, label: `8 ${this.translateService.instant(marker('common.label.hour_code'))}`}
        ];
    }

    protected calculateEndDatetime(): Date | false {
        if (this.selectedPeriod) {
            const daMoment = moment();
            daMoment.add(this.selectedPeriod, 'minutes');
            return daMoment.toDate();
        } else {
            return false;
        }
    }

    public accept(): void {
        this.periodError = !this.selectedPeriod;

        if (!this.periodError) {
            const expiration = this.calculateEndDatetime();

            if (expiration) {
                this.sessionService.allowSupportAccess(expiration)
                                   .subscribe((result) => {
                    this.dialogRef.close(true);
                });
            }
        }
    }

    public close(): void {
        this.dialogRef.close(false);
    }

}
